import type React from "react";
import { Box, Container, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { IconMaintenance } from "src/assets/iconMaintenance";
import logoDirecional from "../../assets/logo_small.svg";
import { theme } from "src/styles/theme";

const Maintenance: React.FC = () => {
  return (
    <Box
      display={"flex"}
      minH="100vh"
      bg={theme.backgroundGray}
      alignItems={"center"}
      justifyContent={"center"}
    >
      {/* Logo no canto superior esquerdo */}
      <Box position="absolute" top="4" left="4" w="33px" h="33px">
        <Image
          src={logoDirecional || "/placeholder.svg"}
          alt="logoDirecional"
        />
      </Box>

      <Container
        display={"flex"}
        maxW="container.md"
        h={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Flex direction="column" align="center" textAlign="center">
          {/* Espaço para a ilustração principal */}
          <Box
            w={{ base: "240px", md: "320px" }}
            h={{ base: "180px", md: "240px" }}
            mb={{ base: 6, md: 10 }}
            position="relative"
          >
            {/* Substitua pelo seu SVG de ilustração */}
            <IconMaintenance width="100%" height="100%" />
          </Box>

          {/* Título */}
          <Heading
            as="h1"
            fontSize={{ base: "2xl", md: "3xl" }}
            fontWeight="medium"
            color={theme.text}
            mb={4}
          >
            Portal em manutenção
          </Heading>

          {/* Texto explicativo */}
          <Text
            fontSize={{ base: "13px", md: "15px" }}
            color={theme.text50}
            maxW="450px"
            px={4}
          >
            O Bora Vender está passando por uma rápida manutenção e estará de
            volta em breve. Obrigado pela paciência.
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Maintenance;
